/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-03-14 16:50:38
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-14 21:05:57
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/product/selectModelGroup.tsx
 * @Description: default
 */
import { dataExpTagConfig } from '@/components/product/const';
import { EXPOSURE_RECORD } from '@/tracks/25217';
import { Fragment } from 'react';
// styles
import SafeLink from '@/components/SafeLink';
import { useTranslation } from '@/i18n/client';
import { SelectModelGroupWrapper } from '@/styles/product';
import { AttrUtils, ButtonPartVo, ColorSizePartVo } from '@/utils/attrUtils';
import { formatProductLink } from '@/utils/formatProductLink';
import CDNImage from '../cdnImage/cdnImage';
import cn from 'clsx';

const colorSizePartListAddCheckedAttr = (colorSizePartList: ColorSizePartVo[], skuId: string) => {
  // console.log(JSON.stringify(colorSizePartList));
  // 给每一个buttonPart选项添加是否被选中的属性
  for (const colorSizePart of colorSizePartList) {
    for (const buttonPart of colorSizePart.buttonPartList || []) {
      buttonPart.checked = buttonPart.skuList?.includes(skuId) || false;
    }
  }
  // 给每一个buttonPart选项添加点击之后跳转的目标skuid
  for (const [dimensionIndex, colorSizePart] of colorSizePartList.entries()) {
    for (const buttonPart of colorSizePart.buttonPartList || []) {
      const otherDimensionSkuids = colorSizePartList
        .filter((v, i) => dimensionIndex !== i)
        .map((v) => v.buttonPartList)
        .flat()
        .filter((b) => b?.checked)
        .map((v) => v?.skuList)
        .filter((v) => v !== undefined);

      buttonPart.targetSkuId = AttrUtils.getSkuIntersect([
        ...otherDimensionSkuids,
        buttonPart.skuList || [],
      ])?.[0];
      if (!buttonPart.targetSkuId) {
        const anotherDimensionSkuids = colorSizePartList
          .filter((v, i) => dimensionIndex !== i)
          .map((v) => v.buttonPartList)
          .flat()
          // .filter((b) => !b?.checked)
          .map((v) => v?.skuList)
          .filter((v) => v !== undefined);
        const mutipleTargetIds: string[] = [];
        anotherDimensionSkuids.forEach((item) => {
          const tempTargetId = AttrUtils.getSkuIntersect([item, buttonPart.skuList || []])?.[0];
          mutipleTargetIds.push(tempTargetId);
        });
        buttonPart.targetSkuId = buttonPart.skuList?.filter((v) =>
          mutipleTargetIds.includes(v),
        )?.[0];
        buttonPart.status = 0;

        // anotherDimensionSkuids.forEach((child: string[])=> {
        //   AttrUtils.getSkuIntersect([...child, buttonPart.skuList || []])?.[0];
        // } )
      }
    }
  }
};

export default function SelectModelGroup({ floors, spuTitle }: any) {
  const productSelectedFloor = floors.productSelectedFloor?.data;
  const productSeriesFloor = floors.productSeriesFloor?.data;
  const colorSizePartList: ColorSizePartVo[] = (productSelectedFloor?.colorSizePartList || []).map(
    (v: any) => ({
      ...v['C-P#dimension&dimension'],
      buttonPartList:
        v.buttonPartList?.map((k: any) => ({ ...k['C-P#dimensionButton&dimensionButton'] })) || [],
    }),
  );
  const skuStatus = productSelectedFloor?.skuStatus;
  const skuId = floors?.productDetailFloor?.data?.productDetailReqParam?.skuId;
  colorSizePartListAddCheckedAttr(colorSizePartList, skuId);
  // console.log(JSON.stringify(colorSizePartList));
  const { t } = useTranslation();
  const getSelectPartText = (parts: ButtonPartVo[]) => {
    let partText: string = '';
    parts.forEach((part: ButtonPartVo) => {
      if (part.checked) {
        partText = part.text as string;
      }
    });
    return partText;
  };

  const { seriesGroupName, widthSeletedSeries } =
    productSeriesFloor?.series?.reduce((prev: any, next: any) => {
      if (next?.skus?.includes(skuId)) {
        prev.seriesGroupName = next.name;
        prev.widthSeletedSeries = [...(prev.widthSeletedSeries || []), { ...next, checked: true }];
      } else {
        prev.widthSeletedSeries = [...(prev.widthSeletedSeries || []), { ...next, checked: false }];
      }
      return prev;
    }, {}) || {};

  return (
    <SelectModelGroupWrapper>
      {productSeriesFloor?.series && (
        <div
          className='group'
          key={100}
          exptag={'exp|' + EXPOSURE_RECORD.Productdetail_Specification_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({
            mainskuid: skuId,
            specificationType: 'Series',
          })}
        >
          <div className='head'>
            {t('dp.selectedGroup.series')}:<span>{seriesGroupName}</span>
          </div>
          <div className='content'>
            {widthSeletedSeries?.map((b: any) => {
              return (
                <SafeLink key={b.id} href={formatProductLink(b.skus?.[0])}>
                  <div className={`item text ${b.checked ? 'active' : ''}`}>{b.name}</div>
                </SafeLink>
              );
            })}
          </div>
        </div>
      )}
      {colorSizePartList.map((v, index) => (
        <div
          className='group'
          key={v.dimensionNumber}
          exptag={'exp|' + EXPOSURE_RECORD.Productdetail_Specification_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({
            mainskuid: skuId,
            specificationType: v.dimTitle,
          })}
        >
          <div className='head'>
            {v.dimTitle}
            <span>{`: ${getSelectPartText(v.buttonPartList as ButtonPartVo[])}`}</span>
          </div>
          <div className='content'>
            {v.buttonPartList &&
              v.buttonPartList.map((b) => {
                const zone = (
                  <div
                    className={cn('item', {
                      imgV1: b.imgUrl,
                      text: !b.imgUrl,
                      disabled: !b.targetSkuId,
                      active: b.checked,
                      noStock:
                        b.targetSkuId &&
                        (b?.status === 0 ||
                          (skuStatus?.[b.targetSkuId] !== '0' && (b.checked || b?.status !== 0))),
                    })}
                    key={b.skuList?.join('')}
                  >
                    {b.imgUrl && (
                      <CDNImage src={b.imgUrl as string} width={60} height={60} alt='image' />
                    )}
                    <div className='skuName'>{b.text}</div>
                  </div>
                );

                return (
                  <Fragment key={b.skuList?.join('')}>
                    {b.targetSkuId ? (
                      <SafeLink
                        href={`${formatProductLink(b.targetSkuId, spuTitle)}?ref_sku=${b.targetSkuId}`}
                        trackClickParams={{
                          event_id: 'Productdetail_SwitchSku',
                          json_param: () => ({
                            mainskuid: sessionStorage.getItem('initial_skuid') || skuId,
                            skuid: b.targetSkuId,
                            skuStatus: Math.abs(parseInt(skuStatus?.[b.targetSkuId!] || '0', 10)),
                          }),
                        }}
                      >
                        {zone}
                      </SafeLink>
                    ) : (
                      zone
                    )}
                  </Fragment>
                );
              })}
          </div>
        </div>
      ))}
    </SelectModelGroupWrapper>
  );
}
